'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  align-items: center;\n  display: none;\n  flex-direction: row;\n  margin-bottom: ', ';\n  margin-left: auto;\n  margin-right: auto;\n  margin-top: ', ';\n  width: ', ';\n\n  ', '\n\n  &::before,\n  &::after {\n    border: 1px solid ', ';\n    content: \'\';\n    display: block;\n    margin: 0 10px;\n    width: 50%;\n  }\n\n  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n    svg {\n      width: 45px;\n    }\n  }\n\n  @media(min-width: ', ') {\n    display: flex;\n  }\n'], ['\n  align-items: center;\n  display: none;\n  flex-direction: row;\n  margin-bottom: ', ';\n  margin-left: auto;\n  margin-right: auto;\n  margin-top: ', ';\n  width: ', ';\n\n  ', '\n\n  &::before,\n  &::after {\n    border: 1px solid ', ';\n    content: \'\';\n    display: block;\n    margin: 0 10px;\n    width: 50%;\n  }\n\n  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n    svg {\n      width: 45px;\n    }\n  }\n\n  @media(min-width: ', ') {\n    display: flex;\n  }\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _config = require('../../../config.js');

var _mixins = require('../../../mixins');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Wrapper = _styledComponents2.default.div(_templateObject, function (props) {
  return props.$hasBottomMargin ? '30px' : '0';
}, function (props) {
  return props.$hasTopMargin ? '30px' : '0';
}, function (props) {
  return props.width || '75%';
}, function (props) {
  return props.$hasTopMargin || props.$hasBottomMargin ? (0, _mixins.ClearFix)() : '';
}, _config.colors.gray, _config.breakpoints.m);

Wrapper.displayName = 'Wrapper';

exports.default = Wrapper;